import { combineReducers } from 'redux';

import magazineContribute from './magazineContribute/reducer';

export default combineReducers({
  magazineContribute
});



/** WEBPACK FOOTER **
 ** ./src/members/state/magazine/textEditing/reducer.js
 **/